import Banner from "../Components/Shared/Layout/Banner";
import IntroBlock from "../Components/Shared/Layout/IntroBlock";
import withLanguage from "../HOC/withLanguage";
import {AccordionBody, AccordionContainer, AccordionTitle} from "../Components/Shared/Layout/InstitutionAccordion";
import React from "react";
import {useNavigate} from "react-router-dom";
import {useDispatch} from "react-redux";
import {schoolFilterChange} from "../redux/reducers/schoolFiltersSlice";
import {degreeFilterChange} from "../redux/reducers/degreeFiltersSlice";
import Button from "@mui/material/Button";
import Image from "../Components/Shared/Layout/Image";

const ArsimiIMesem = ({language}) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const iconConfig = [
        {
            src: "/edPower.png",
            maxWidth: "max-w-[120px]",
            text1: "icon1",
            text2: "icon11",
        },
        {
            src: "/newProf.svg",
            maxWidth: "max-w-[100px]",
            text1: "icon2",
            text2: "icon22",
        },
        {
            src: "/teamBridge.svg",
            maxWidth: "max-w-[100px]",
            text1: "icon3",
            text2: "icon33",
        },
    ];


    return (
        <>
            <Banner img='/ArsimiIMesem/Picture4.jpg' title={language.banner}/>
            <div className="text-justify m-5 xl:mx-[15rem] lg:mx-[7rem] md:mx-[3rem] xs:mx-[2.5rem]">
                <p className="text-xl font-bold text-red-600">{language["title0"]}</p>
                <div className="flex justify-between max-md:flex-col items-center mx-8">
                    {iconConfig.map((item, idx) => (
                        <div key={idx} className="flex justify-center items-center gap-2">
                            <Image className={item.maxWidth} src={item.src} alt="" />
                            <div className="flex flex-col text-red-600 font-bold text-lg">
                                <p>{language[item.text1]}</p>
                                <p>{language[item.text2]}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <div className="text-[17px] leading-7">
                    <p>
                        {language["intro_pre"]} <strong className="font-bold">{language["institutions"]}</strong> {language["intro_post"]}
                    </p>

                    <ul className="mt-3 space-y-2">
                        <li className="flex items-start">
                            <span className="mt-[2px] mr-2 text-red-600">✓</span>
                            <div>
                                <span className="text-red-600 font-semibold">{language["bullet1_lead"]}</span>{" "}
                                <span>{language["bullet1_tail"]}</span>
                            </div>
                        </li>
                        <li className="flex items-start">
                            <span className="mt-[2px] mr-2 text-red-600">✓</span>
                            <div>
                                <span className="text-red-600 font-semibold">{language["bullet2_lead"]}</span>{" "}
                                <span>{language["bullet2_tail"]}</span>
                            </div>
                        </li>
                    </ul>

                    <p className="mt-3">{language["outro"]}</p>
                </div>
                <div className="flex max-md:flex-col gap-6">
                    <AccordionContainer
                        panel="panel2"
                        sx={{
                            '&.Mui-expanded': { m: 0 },
                        }}
                    >
                        <AccordionTitle title={language.title1}/>
                        <AccordionBody>
                            <p className="text-lg py-2">{language.ShkollaP1}</p>
                            <p className="text-lg py-2">{language.ShkollaP2}</p>
                            <p className="text-lg py-2">{language.ShkollaP3}</p>
                            <p className="text-lg py-2">{language.ShkollaP4}</p>
                            <p className="text-lg py-2">
                                {language.ShkollaP5}
                                <br/>
                                <Button onClick={() => {
                                    dispatch(degreeFilterChange("drejtim"))
                                    navigate("/drejtime")
                                }} sx={{
                                    color: '#1565c0',
                                    background: 'transparent',
                                    textTransform: "none",
                                    boxShadow: 'none',
                                    minWidth: 'auto',
                                    padding: '0',
                                    fontSize: '1.125rem',
                                    fontWeight: "400",
                                    "&:hover": {background: 'transparent', boxShadow: 'none'},
                                }}>{language.link}</Button>
                            </p>
                            <button onClick={() => {
                                dispatch(schoolFilterChange("shkolla"))
                                navigate("/shkollat")
                            }} style={{
                                color: '#1565c0',
                                background: 'transparent',
                                boxShadow: 'none',
                                minWidth: 'auto',
                                padding: '0',
                                fontSize: '1.125rem',
                                fontWeight: "400",
                                "&:hover": {background: 'transparent', boxShadow: 'none'},
                            }}>{language.shkolla}</button>

                        </AccordionBody>
                    </AccordionContainer>
                    <AccordionContainer
                        panel="panel2"
                        sx={{
                            '&.Mui-expanded': { m: 0 },
                        }}
                    >
                        <AccordionTitle title={language.title2}/>
                        <AccordionBody>
                            <p className="text-lg py-2">
                                {language.arsimiPasTeMesem}
                                <Button onClick={() => {
                                    dispatch(degreeFilterChange("middle"))
                                    navigate("/drejtime")
                                }} sx={{
                                    color: '#1565c0',
                                    background: 'transparent',
                                    textTransform: 'none',
                                    boxShadow: 'none',
                                    minWidth: 'auto',
                                    padding: '0',
                                    fontSize: '1.125rem',
                                    fontWeight: "400",
                                    "&:hover": {background: 'transparent', boxShadow: 'none'}
                                }}>{language.arsimiLink}</Button>
                            </p>

                            <button onClick={() => {
                                dispatch(schoolFilterChange("drejtimi_mesem"))
                                navigate("/shkollat")
                            }} style={{
                                color: '#1565c0',
                                background: 'transparent',
                                boxShadow: 'none',
                                minWidth: 'auto',
                                padding: '0',
                                fontSize: '1.125rem',
                                fontWeight: "400",
                                "&:hover": {background: 'transparent', boxShadow: 'none'},
                            }}>{language.shkolla}</button>

                        </AccordionBody>
                    </AccordionContainer>
                </div>

                {/*<AccordionContainer panel="panel3">*/}
                {/*    <AccordionTitle title={language.title3} />*/}
                {/*    <AccordionBody>*/}
                {/*        <p className="text-lg py-2">{language.centerP1}</p>*/}
                {/*        <p className="text-lg py-2">{language.centerP2}</p>*/}
                {/*        <p className="text-lg py-2">{language.centerP3}</p>*/}
                {/*        <p className="text-lg py-2">{language.centerP4}</p>*/}

                {/*        <p className="text-lg py-2">*/}
                {/*            {language.centerP5}*/}
                {/*            <br />*/}
                {/*            <Button onClick={()=>{*/}
                {/*                dispatch(degreeFilterChange("kurs"))*/}
                {/*                navigate("/drejtime")*/}
                {/*            }} sx={{color: '#1565c0', background: 'transparent', textTransform:'none', boxShadow: 'none', minWidth: 'auto', padding: '0', fontSize: '1.125rem', fontWeight: "400",*/}
                {/*                "&:hover": {background: 'transparent', boxShadow: 'none'},}}>{language.centerLink}</Button>*/}
                {/*        </p>*/}
                {/*        <button onClick={()=>{*/}
                {/*            dispatch(schoolFilterChange("qendra"))*/}
                {/*            navigate("/shkollat")*/}
                {/*        }} style={{color: '#1565c0', background: 'transparent', boxShadow: 'none', minWidth: 'auto', padding: '0', fontSize: '1.125rem', fontWeight: "400",*/}
                {/*            "&:hover": {background: 'transparent', boxShadow: 'none'},}}>{language.qendra}</button>*/}

                {/*    </AccordionBody>*/}
                {/*</AccordionContainer>*/}
            </div>

        </>
    )
}

export default withLanguage(ArsimiIMesem, "Highschool")